import { createSelector } from "@reduxjs/toolkit";
import { selectShippingMethods } from "../selectShippingMethods";
export const selectFirstAvailableShippingMethod = createSelector([(state) => state, (_, isFreeTrial) => isFreeTrial], (state, isFreeTrial) => {
    const shippingMethods = selectShippingMethods(state, isFreeTrial);
    return shippingMethods.data.find((method) => method.available);
});
//# sourceMappingURL=selectFirstAvailableShippingMethod.js.map